module.exports = [
  {
    id: "421",
    word: "wietrzny/wietrznie"
  },
  {
    id: "429",
    word: "szybki/szybko"
  },
  {
    id: "498",
    word: "wczesny/wcześnie"
  },
  {
    id: "525",
    word: "wózek dziecięcy"
  },
  {
    id: "47",
    word: "przyjaciel/przyjaciółka"
  },
  {
    id: "107",
    word: "artysta/artystka"
  },
  {
    id: "184",
    word: "fryzjer/fryzjerka"
  },
  {
    id: "277",
    word: "student/studentka"
  },
  {
    id: "296",
    word: "współlokator/współlokatorka"
  },
  {
    id: "381",
    word: "policjant/policjantka"
  },
  {
    id: "420",
    word: "nauczyciel/nauczycielka"
  },
  {
    id: "430",
    word: "piosenkarz/piosenkarka"
  },
  {
    id: "520",
    word: "sąsiad/sąsiadka"
  },
  {
    id: "532",
    word: "malarz/malarka"
  },
  {
    id: "537",
    word: "agent/agentka"
  },
  {
    id: "574",
    word: "kuzyn/kuzynka"
  },
  {
    id: "602",
    word: "kelner/kelnerka"
  },
  {
    id: "616",
    word: "prawnik/prawniczka"
  },
  {
    id: "618",
    word: "turysta/turystka"
  },
  {
    id: "710",
    word: "bohater/bohaterka"
  },
  {
    id: "715",
    word: "pasażer/pasażerka"
  },
  {
    id: "780",
    word: "farmaceuta/farmaceutka"
  },
  {
    id: "894",
    word: "klient/klientka"
  },
  {
    id: "900",
    word: "poeta/poetka"
  },
  {
    id: "919",
    word: "asystent/asystentka"
  },
  {
    id: "928",
    word: "lider/liderka"
  },
  {
    id: "962",
    word: "pracownik/pracownica"
  },
  {
    id: "984",
    word: "bliźniak/bliźniaczka"
  },
  {
    id: "1170",
    word: "morderca/morderczyni"
  },
  {
    id: "1179",
    word: "pacjent/pacjentka"
  },
  {
    id: "1218",
    word: "towarzysz/towarzyszka"
  },
  {
    id: "1213",
    word: "buddysta/buddystka"
  },
  {
    id: "1281",
    word: "wojownik/wojowniczka"
  },
  {
    id: "1292",
    word: "zwycięzca/zwycięższczyni"
  },
  {
    id: "1298",
    word: "niewolnik/niewolnica"
  },
  {
    id: "1384",
    word: "dowódca/dowódczyni"
  },
  {
    id: "1422",
    word: "reporter/reporterka"
  },
  {
    id: "1517",
    word: "obywatel/obywatelka"
  },
  {
    id: "1572",
    word: "trener/trenerka"
  },
  {
    id: "1592",
    word: "czytelnik/czytelniczka"
  },
  {
    id: "1598",
    word: "nastolatek/nastolatka"
  },
  {
    id: "1632",
    word: "kolega/koleżanka"
  },
  {
    id: "1796",
    word: "Niemiec/Niemka"
  },
  {
    id: "1833",
    word: "imigrant/imigrantka"
  },
  {
    id: "1841",
    word: "złodziej/złodziejka"
  },
  {
    id: "1853",
    word: "właściciel/właścicielka"
  },
  {
    id: "1968",
    word: "łucznik/łuczniczka"
  },
  {
    id: "2062",
    word: "muzułmanin/muzułmanka"
  },
  {
    id: "2184",
    word: "chrześcijanin/chrześcijanka"
  },
  {
    id: "2122",
    word: "uczestnik/uczestniczka"
  },
  {
    id: "2227",
    word: "wojownik/wojowniczka"
  },
  {
    id: "2337",
    word: "kompozytor/kompozytorka"
  },
  {
    id: "2392",
    word: "uczeń/uczennica"
  },
  {
    id: "2433",
    word: "operator/operatorka kamery"
  },
  {
    id: "2556",
    word: "ratownik/ratowniczka"
  },
  {
    id: "2665",
    word: "zwycięzca/zwycięższczyni"
  },
  {
    id: "2737",
    word: "kandydat/kandydatka"
  },
  {
    id: "2760",
    word: "dyrektor/dyrektorka szkoły"
  },
  {
    id: "2849",
    word: "wolontariusz/wolontariuszka"
  },
  {
    id: "2857",
    word: "recepcjonista/recepcjonistka"
  },
  {
    id: "2879",
    word: "sprzedawca/sprzedawczyni"
  },
  {
    id: "2880",
    word: "terapeuta/terapeutka"
  },
  {
    id: "2901",
    word: "bibliotekarz/bibliotekarka"
  },
  {
    id: "3008",
    word: "projektant/projektantka"
  },
  {
    id: "3010",
    word: "dziedzic/dziedziczka"
  },
  {
    id: "3038",
    word: "zabójca/zabójczyni"
  },
  {
    id: "3041",
    word: "dziennikarz/dziennikarka"
  },
  {
    id: "3049",
    word: "strażnik/strażniczka więzienna"
  },
  {
    id: "3104",
    word: "buntownik/buntowniczka"
  },
  {
    id: "3111",
    word: "uchodźca/uchodźczyni"
  },
  {
    id: "3293",
    word: "zakładnik/zakładniczka"
  },
  {
    id: "3441",
    word: "kasjer/kasjerka"
  },
  {
    id: "9",
    word: "spróbować"
  },
  {
    id: "13",
    word: "ręka"
  },
  {
    id: "46",
    word: "imię"
  },
  {
    id: "54",
    word: "robić"
  },
  {
    id: "55",
    word: "wierzyć"
  },
  {
    id: "61",
    word: "rano"
  },
  {
    id: "85",
    word: "kieliszek"
  },
  {
    id: "119",
    word: "zawód"
  },
  {
    id: "174",
    word: "odwiedzający"
  },
  {
    id: "175",
    word: "pani"
  },
  {
    id: "190",
    word: "surowy"
  },
  {
    id: "204",
    word: "mieszkać"
  },
  {
    id: "205",
    word: "zgubić"
  },
  {
    id: "208",
    word: "powiedzieć"
  },
  {
    id: "214",
    word: "ubrania"
  },
  {
    id: "215",
    word: "wyczuwać"
  },
  {
    id: "220",
    word: "obiad"
  },
  {
    id: "221",
    word: "hala"
  },
  {
    id: "251",
    word: "znaleźć"
  },
  {
    id: "259",
    word: "powiesić"
  },
  {
    id: "265",
    word: "centrum"
  },
  {
    id: "291",
    word: "hamburger"
  },
  {
    id: "295",
    word: "karta"
  },
  {
    id: "301",
    word: "boleć"
  },
  {
    id: "321",
    word: "dziura"
  },
  {
    id: "389",
    word: "ważny"
  },
  {
    id: "403",
    word: "podążać"
  },
  {
    id: "442",
    word: "plastik"
  },
  {
    id: "453",
    word: "oglądać"
  },
  {
    id: "468",
    word: "okrąg"
  },
  {
    id: "481",
    word: "biedny"
  },
  {
    id: "549",
    word: "padać"
  },
  {
    id: "553",
    word: "czatować"
  },
  {
    id: "590",
    word: "ludzie"
  },
  {
    id: "613",
    word: "gospodarstwo rolne"
  },
  {
    id: "652",
    word: "kreatywny"
  },
  {
    id: "653",
    word: "żonaty/zamężna"
  },
  {
    id: "665",
    word: "siła"
  },
  {
    id: "716",
    word: "miara kraiwcka"
  },
  {
    id: "722",
    word: "broda"
  },
  {
    id: "734",
    word: "cel"
  },
  {
    id: "756",
    word: "sekretarka"
  },
  {
    id: "815",
    word: "ksiądz"
  },
  {
    id: "830",
    word: "zawodnik/zawodniczka"
  },
  {
    id: "878",
    word: "paczka"
  },
  {
    id: "880",
    word: "pocisk"
  },
  {
    id: "927",
    word: "uczucie"
  },
  {
    id: "963",
    word: "tabletka"
  },
  {
    id: "991",
    word: "uraz"
  },
  {
    id: "1000",
    word: "dorosły"
  },
  {
    id: "1002",
    word: "podsłuchiwać"
  },
  {
    id: "1005",
    word: "kusić"
  },
  {
    id: "1009",
    word: "zerknąć"
  },
  {
    id: "1010",
    word: "reprezentować"
  },
  {
    id: "1015",
    word: "wymieniać"
  },
  {
    id: "1020",
    word: "małż"
  },
  {
    id: "1021",
    word: "społeczność"
  },
  {
    id: "1023",
    word: "taśma"
  },
  {
    id: "1025",
    word: "patyczek higieniczny"
  },
  {
    id: "1028",
    word: "koszyk"
  },
  {
    id: "1029",
    word: "kajdanki"
  },
  {
    id: "1035",
    word: "wybrzeże"
  },
  {
    id: "1036",
    word: "ogólny"
  },
  {
    id: "1042",
    word: "społeczeństwo"
  },
  {
    id: "1045",
    word: "rozkaz"
  },
  {
    id: "1046",
    word: "sekunda"
  },
  {
    id: "1047",
    word: "model/modelka"
  },
  {
    id: "1048",
    word: "czołg"
  },
  {
    id: "1055",
    word: "pokonać"
  },
  {
    id: "1066",
    word: "kolarstwo"
  },
  {
    id: "1069",
    word: "łucznictwo"
  },
  {
    id: "1071",
    word: "szczyt"
  },
  {
    id: "1079",
    word: "zmieniać biegi"
  },
  {
    id: "1081",
    word: "cukierek"
  },
  {
    id: "1083",
    word: "cienki"
  },
  {
    id: "1089",
    word: "mina lądowa"
  },
  {
    id: "1096",
    word: "obozować"
  },
  {
    id: "1101",
    word: "wspominać"
  },
  {
    id: "1102",
    word: "walczyć w zapasach"
  },
  {
    id: "1104",
    word: "podnosić"
  },
  {
    id: "1107",
    word: "grać w karty"
  },
  {
    id: "1111",
    word: "bankomat"
  },
  {
    id: "1112",
    word: "jeździectwo"
  },
  {
    id: "1121",
    word: "służący/służąca"
  },
  {
    id: "1130",
    word: "odejmować"
  },
  {
    id: "1131",
    word: "kołnierz"
  },
  {
    id: "1136",
    word: "wspinaczka"
  },
  {
    id: "1140",
    word: "młodość"
  },
  {
    id: "1141",
    word: "dmuchać"
  },
  {
    id: "1150",
    word: "przedstawić"
  },
  {
    id: "1153",
    word: "zaspać"
  },
  {
    id: "1159",
    word: "zwlekać"
  },
  {
    id: "1160",
    word: "fan/fanka"
  },
  {
    id: "1174",
    word: "popyt"
  },
  {
    id: "1183",
    word: "szafa"
  },
  {
    id: "1188",
    word: "pokój dziecięcy"
  },
  {
    id: "1192",
    word: "cudzysłów"
  },
  {
    id: "1193",
    word: "zamknięty"
  },
  {
    id: "1195",
    word: "jelito grube"
  },
  {
    id: "1196",
    word: "myślnik"
  },
  {
    id: "1199",
    word: "związek"
  },
  {
    id: "1202",
    word: "uwodzić"
  },
  {
    id: "1212",
    word: "aktywność"
  },
  {
    id: "1215",
    word: "ul"
  },
  {
    id: "1216",
    word: "skręcać"
  },
  {
    id: "1217",
    word: "klucz"
  },
  {
    id: "1222",
    word: "uhonorować"
  },
  {
    id: "1225",
    word: "talia"
  },
  {
    id: "1229",
    word: "ekscytacja"
  },
  {
    id: "1232",
    word: "futro"
  },
  {
    id: "1233",
    word: "sektor"
  },
  {
    id: "1241",
    word: "mundur"
  },
  {
    id: "1244",
    word: "śnieżka"
  },
  {
    id: "1245",
    word: "oba/obaj/obie/oboje"
  },
  {
    id: "1247",
    word: "suma"
  },
  {
    id: "1249",
    word: "florysta/florystka"
  },
  {
    id: "1251",
    word: "gardło"
  },
  {
    id: "1257",
    word: "pryskać"
  },
  {
    id: "1260",
    word: "guzik"
  },
  {
    id: "1263",
    word: "farba"
  },
  {
    id: "1271",
    word: "Holandia"
  },
  {
    id: "1275",
    word: "dać napiwek"
  },
  {
    id: "1282",
    word: "okoliczność"
  },
  {
    id: "1297",
    word: "gruby"
  },
  {
    id: "1299",
    word: "nieuczciwy"
  },
  {
    id: "1300",
    word: "beczka"
  },
  {
    id: "1301",
    word: "torturować"
  },
  {
    id: "1302",
    word: "zgłaszać"
  },
  {
    id: "1329",
    word: "surowy"
  },
  {
    id: "1277",
    word: "cichy/cicho"
  },
  {
    id: "1329",
    word: "ostry"
  },
  {
    id: "1332",
    word: "Amerykanin/Amerykanka"
  },
  {
    id: "1343",
    word: "gryz"
  },
  {
    id: "1345",
    word: "przysługa"
  },
  {
    id: "1346",
    word: "biblioteczka"
  },
  {
    id: "1354",
    word: "dokładny"
  },
  {
    id: "1356",
    word: "podnosić"
  },
  {
    id: "1360",
    word: "piec"
  },
  {
    id: "1361",
    word: "nieruchomość"
  },
  {
    id: "1362",
    word: "personel"
  },
  {
    id: "1363",
    word: "palić"
  },
  {
    id: "1364",
    word: "być spragnionym"
  },
  {
    id: "1368",
    word: "worek"
  },
  {
    id: "1370",
    word: "natłuszczać"
  },
  {
    id: "1376",
    word: "pałeczka"
  },
  {
    id: "1377",
    word: "ostatni"
  },
  {
    id: "1381",
    word: "pomarańcza"
  },
  {
    id: "1383",
    word: "nieszczęśliwy"
  },
  {
    id: "1387",
    word: "trening"
  },
  {
    id: "1396",
    word: "design"
  },
  {
    id: "1398",
    word: "żyletka"
  },
  {
    id: "1401",
    word: "włączyć"
  },
  {
    id: "1404",
    word: "przyjechać"
  },
  {
    id: "1407",
    word: "polować"
  },
  {
    id: "1408",
    word: "być zlokalizowanym"
  },
  {
    id: "1411",
    word: "dzwonić"
  },
  {
    id: "1415",
    word: "objętość"
  },
  {
    id: "1419",
    word: "ślad"
  },
  {
    id: "1424",
    word: "kajak"
  },
  {
    id: "1427",
    word: "zepsuty"
  },
  {
    id: "1429",
    word: "burak"
  },
  {
    id: "1439",
    word: "słodki ziemniak"
  },
  {
    id: "1454",
    word: "skręcenie"
  },
  {
    id: "1455",
    word: "figa"
  },
  {
    id: "1458",
    word: "roztopić się"
  },
  {
    id: "1462",
    word: "wakacje"
  },
  {
    id: "1465",
    word: "szkoda"
  },
  {
    id: "1471",
    word: "żebro"
  },
  {
    id: "1472",
    word: "zeszyt"
  },
  {
    id: "1481",
    word: "pręt"
  },
  {
    id: "1484",
    word: "głośny"
  },
  {
    id: "1485",
    word: "granica"
  },
  {
    id: "1486",
    word: "żywy"
  },
  {
    id: "1386",
    word: "delikatny"
  },
  {
    id: "1496",
    word: "krzak"
  },
  {
    id: "1498",
    word: "przylot"
  },
  {
    id: "1501",
    word: "płynąć"
  },
  {
    id: "1505",
    word: "niszczyć"
  },
  {
    id: "1508",
    word: "drżeć"
  },
  {
    id: "1511",
    word: "poświęcać"
  },
  {
    id: "1512",
    word: "byk"
  },
  {
    id: "1513",
    word: "nasiono"
  },
  {
    id: "1515",
    word: "nieszkodliwy"
  },
  {
    id: "1518",
    word: "jasny"
  },
  {
    id: "1529",
    word: "sławny"
  },
  {
    id: "1539",
    word: "instrukcja"
  },
  {
    id: "1546",
    word: "materiał"
  },
  {
    id: "1553",
    word: "pozwolić"
  },
  {
    id: "1556",
    word: "oszukać"
  },
  {
    id: "1567",
    word: "zmęczony"
  },
  {
    id: "1570",
    word: "przestraszony"
  },
  {
    id: "1574",
    word: "głośnik"
  },
  {
    id: "1578",
    word: "suchy"
  },
  {
    id: "1587",
    word: "krewny"
  },
  {
    id: "1589",
    word: "otwarty"
  },
  {
    id: "1603",
    word: "gotować"
  },
  {
    id: "1607",
    word: "dosięgnąć"
  },
  {
    id: "1611",
    word: "czysty"
  },
  {
    id: "1615",
    word: "gest"
  },
  {
    id: "1618",
    word: "zabałaganiony"
  },
  {
    id: "1627",
    word: "Hindus/Hinduska"
  },
  {
    id: "1640",
    word: "wyniki"
  },
  {
    id: "1646",
    word: "wędrówka"
  },
  {
    id: "1647",
    word: "punktualny"
  },
  {
    id: "1650",
    word: "nalewać"
  },
  {
    id: "1653",
    word: "suszyć"
  },
  {
    id: "1655",
    word: "gotować"
  },
  {
    id: "1656",
    word: "poskromić"
  },
  {
    id: "1659",
    word: "sztuki walki"
  },
  {
    id: "1662",
    word: "puls"
  },
  {
    id: "1663",
    word: "nieobecność"
  },
  {
    id: "1667",
    word: "interakcja"
  },
  {
    id: "1673",
    word: "drobny"
  },
  {
    id: "1674",
    word: "pełny"
  },
  {
    id: "1675",
    word: "upodobanie"
  },
  {
    id: "1693",
    word: "konstrukcja"
  },
  {
    id: "1696",
    word: "foka"
  },
  {
    id: "1703",
    word: "przyjazny"
  },
  {
    id: "1705",
    word: "pukać"
  },
  {
    id: "1707",
    word: "szczotkować"
  },
  {
    id: "1708",
    word: "żuć"
  },
  {
    id: "1714",
    word: "łupież"
  },
  {
    id: "1715",
    word: "mieć powinność"
  },
  {
    id: "1716",
    word: "ostry"
  },
  {
    id: "1719",
    word: "opinia"
  },
  {
    id: "1725",
    word: "zanieczyszenie"
  },
  {
    id: "1727",
    word: "wypadek"
  },
  {
    id: "1729",
    word: "pewny"
  },
  {
    id: "1730",
    word: "niepewny"
  },
  {
    id: "1733",
    word: "owca"
  },
  {
    id: "1735",
    word: "muszka"
  },
  {
    id: "1740",
    word: "ekscytujący"
  },
  {
    id: "1741",
    word: "spiczasty"
  },
  {
    id: "1744",
    word: "tępy"
  },
  {
    id: "1745",
    word: "pierwiastek"
  },
  {
    id: "1746",
    word: "olbrzym"
  },
  {
    id: "1748",
    word: "wysportowany"
  },
  {
    id: "1750",
    word: "niewysportowany"
  },
  {
    id: "1756",
    word: "oddychać"
  },
  {
    id: "1759",
    word: "wyć"
  },
  {
    id: "1765",
    word: "kropka"
  },
  {
    id: "1767",
    word: "dziwny"
  },
  {
    id: "1768",
    word: "kanapa"
  },
  {
    id: "1783",
    word: "nieracjonalny"
  },
  {
    id: "1784",
    word: "kliknięcie"
  },
  {
    id: "1785",
    word: "reputacja"
  },
  {
    id: "1790",
    word: "pilot"
  },
  {
    id: "1804",
    word: "mieszać"
  },
  {
    id: "1805",
    word: "śmierdzieć"
  },
  {
    id: "1806",
    word: "aborcja"
  },
  {
    id: "1807",
    word: "uczyć"
  },
  {
    id: "1812",
    word: "życie"
  },
  {
    id: "1813",
    word: "tancerz/tancerka"
  },
  {
    id: "1822",
    word: "szafka na buty"
  },
  {
    id: "1824",
    word: "płytka"
  },
  {
    id: "1827",
    word: "oddział"
  },
  {
    id: "1828",
    word: "kolano"
  },
  {
    id: "1854",
    word: "napełniać"
  },
  {
    id: "1817",
    word: "poziomy"
  },
  {
    id: "1826",
    word: "mający szczęście"
  },
  {
    id: "1977",
    word: "zbuntowany/buntownik"
  },
  {
    id: "1855",
    word: "oddawać"
  },
  {
    id: "1860",
    word: "niezadowolony"
  },
  {
    id: "1864",
    word: "nie będący w związku"
  },
  {
    id: "1873",
    word: "dziwny"
  },
  {
    id: "1878",
    word: "koszt"
  },
  {
    id: "1886",
    word: "salon"
  },
  {
    id: "1888",
    word: "chłopak"
  },
  {
    id: "1889",
    word: "koralowiec"
  },
  {
    id: "1900",
    word: "zespół muzyczny"
  },
  {
    id: "1901",
    word: "kaszleć"
  },
  {
    id: "1909",
    word: "wbijać"
  },
  {
    id: "1914",
    word: "stopień"
  },
  {
    id: "1920",
    word: "niejasny"
  },
  {
    id: "1926",
    word: "wejście"
  },
  {
    id: "1929",
    word: "głupi"
  },
  {
    id: "1933",
    word: "odsetki"
  },
  {
    id: "1935",
    word: "twierdzenie"
  },
  {
    id: "1940",
    word: "litość"
  },
  {
    id: "1942",
    word: "chaos"
  },
  {
    id: "1947",
    word: "temperówka"
  },
  {
    id: "1960",
    word: "skrócić"
  },
  {
    id: "1963",
    word: "pływ"
  },
  {
    id: "1966",
    word: "obawa"
  },
  {
    id: "1976",
    word: "głupi/głupio"
  },
  {
    id: "1986",
    word: "całkiem"
  },
  {
    id: "1989",
    word: "ładny"
  },
  {
    id: "1990",
    word: "ton"
  },
  {
    id: "1996",
    word: "pragnienie"
  },
  {
    id: "1999",
    word: "świetny"
  },
  {
    id: "2005",
    word: "zmuszać"
  },
  {
    id: "2006",
    word: "wędrować"
  },
  {
    id: "2010",
    word: "mylić"
  },
  {
    id: "2012",
    word: "przyciągać uwagę"
  },
  {
    id: "2017",
    word: "godny zaufania"
  },
  {
    id: "2022",
    word: "spontaniczny"
  },
  {
    id: "2024",
    word: "warunek"
  },
  {
    id: "2029",
    word: "koza"
  },
  {
    id: "2042",
    word: "elegancki"
  },
  {
    id: "2049",
    word: "typowy"
  },
  {
    id: "2051",
    word: "otrzymać"
  },
  {
    id: "2052",
    word: "sprzeczny"
  },
  {
    id: "2058",
    word: "oszczędzać"
  },
  {
    id: "2059",
    word: "wystawiać"
  },
  {
    id: "2060",
    word: "dążyć"
  },
  {
    id: "2067",
    word: "kawałek"
  },
  {
    id: "2070",
    word: "koszulka sportowa"
  },
  {
    id: "2083",
    word: "rzemiosło"
  },
  {
    id: "2089",
    word: "sugestia"
  },
  {
    id: "2094",
    word: "nozdrze"
  },
  {
    id: "2096",
    word: "założyć"
  },
  {
    id: "2099",
    word: "musical"
  },
  {
    id: "2101",
    word: "tonąć"
  },
  {
    id: "2103",
    word: "zawierać"
  },
  {
    id: "2105",
    word: "ławka"
  },
  {
    id: "2107",
    word: "gwizdać"
  },
  {
    id: "2108",
    word: "śmiać się"
  },
  {
    id: "2110",
    word: "przypominać"
  },
  {
    id: "2112",
    word: "klasyfikacja"
  },
  {
    id: "2115",
    word: "jogging"
  },
  {
    id: "2117",
    word: "strona internetowa"
  },
  {
    id: "2119",
    word: "zawstydzający"
  },
  {
    id: "2125",
    word: "zależny"
  },
  {
    id: "2126",
    word: "korzyść"
  },
  {
    id: "2131",
    word: "rafinowany"
  },
  {
    id: "2132",
    word: "łatać"
  },
  {
    id: "2138",
    word: "taczka"
  },
  {
    id: "2142",
    word: "próbka"
  },
  {
    id: "2144",
    word: "sprzedawca/sprzedawczyni"
  },
  {
    id: "2146",
    word: "pośpiech"
  },
  {
    id: "2149",
    word: "nonsens"
  },
  {
    id: "2153",
    word: "zginać"
  },
  {
    id: "2159",
    word: "pomalować"
  },
  {
    id: "2162",
    word: "tost"
  },
  {
    id: "2163",
    word: "grabie"
  },
  {
    id: "2164",
    word: "magazyn"
  },
  {
    id: "2174",
    word: "obecnie"
  },
  {
    id: "2175",
    word: "strefa czasowa"
  },
  {
    id: "2177",
    word: "niedostępny"
  },
  {
    id: "2178",
    word: "wykształcony"
  },
  {
    id: "2181",
    word: "zaawansowany"
  },
  {
    id: "2182",
    word: "len"
  },
  {
    id: "2185",
    word: "ohydny"
  },
  {
    id: "2186",
    word: "sterta"
  },
  {
    id: "2191",
    word: "samotny"
  },
  {
    id: "2195",
    word: "skromny"
  },
  {
    id: "2203",
    word: "okreslić"
  },
  {
    id: "2207",
    word: "szermierka"
  },
  {
    id: "2208",
    word: "kryteria"
  },
  {
    id: "2210",
    word: "podzielić"
  },
  {
    id: "2219",
    word: "przyjemny"
  },
  {
    id: "2241",
    word: "idiota/idiotka"
  },
  {
    id: "2244",
    word: "wysoki"
  },
  {
    id: "2250",
    word: "o wąskich horyzontach"
  },
  {
    id: "2251",
    word: "skakać"
  },
  {
    id: "2252",
    word: "ważyć"
  },
  {
    id: "2255",
    word: "wiązać"
  },
  {
    id: "2257",
    word: "tymczasowy"
  },
  {
    id: "2258",
    word: "kurs"
  },
  {
    id: "2259",
    word: "parzyć"
  },
  {
    id: "2262",
    word: "pierwszej klasy"
  },
  {
    id: "2266",
    word: "oficjalny"
  },
  {
    id: "2270",
    word: "imperium"
  },
  {
    id: "2278",
    word: "skupisko"
  },
  {
    id: "2280",
    word: "nietolerancyjny"
  },
  {
    id: "2289",
    word: "znak"
  },
  {
    id: "2294",
    word: "niestabilny"
  },
  {
    id: "2299",
    word: "kapryśny"
  },
  {
    id: "2300",
    word: "zjeżdżalnia"
  },
  {
    id: "2301",
    word: "pasować"
  },
  {
    id: "2306",
    word: "pozwać"
  },
  {
    id: "2308",
    word: "spłukiwać"
  },
  {
    id: "2310",
    word: "zalać"
  },
  {
    id: "2311",
    word: "plama"
  },
  {
    id: "2313",
    word: "szalony"
  },
  {
    id: "2314",
    word: "zdesperowany"
  },
  {
    id: "2321",
    word: "zmieszany"
  },
  {
    id: "2323",
    word: "inteligencja"
  },
  {
    id: "2324",
    word: "szalony"
  },
  {
    id: "2331",
    word: "wysiłek"
  },
  {
    id: "2336",
    word: "atrament"
  },
  {
    id: "2342",
    word: "paragraf"
  },
  {
    id: "2355",
    word: "kłamać"
  },
  {
    id: "2356",
    word: "pierścionek"
  },
  {
    id: "2358",
    word: "złamać"
  },
  {
    id: "2361",
    word: "pęknięcie"
  },
  {
    id: "2367",
    word: "owieczka"
  },
  {
    id: "2372",
    word: "dziąsło"
  },
  {
    id: "2375",
    word: "magazyn"
  },
  {
    id: "2387",
    word: "mapa"
  },
  {
    id: "2392",
    word: "źrenica"
  },
  {
    id: "2393",
    word: "pamiętnik"
  },
  {
    id: "2396",
    word: "kapeć"
  },
  {
    id: "2401",
    word: "skrzypieć"
  },
  {
    id: "2406",
    word: "spotkać"
  },
  {
    id: "2408",
    word: "sadzić"
  },
  {
    id: "2417",
    word: "finansowy"
  },
  {
    id: "2419",
    word: "relacja"
  },
  {
    id: "2420",
    word: "przypuszczenie"
  },
  {
    id: "2423",
    word: "kolejność"
  },
  {
    id: "2426",
    word: "obiad"
  },
  {
    id: "2431",
    word: "zioło"
  },
  {
    id: "2432",
    word: "pień"
  },
  {
    id: "2441",
    word: "stromy"
  },
  {
    id: "2449",
    word: "rozpoznanie"
  },
  {
    id: "2456",
    word: "kiwnąć głową"
  },
  {
    id: "2459",
    word: "skrzynka na narzędzia"
  },
  {
    id: "2462",
    word: "daleki/daleko"
  },
  {
    id: "2466",
    word: "machać"
  },
  {
    id: "2475",
    word: "kula inwalidzka"
  },
  {
    id: "2483",
    word: "laur"
  },
  {
    id: "2490",
    word: "ogromny"
  },
  {
    id: "2494",
    word: "sznurówka"
  },
  {
    id: "2495",
    word: "bagażnik"
  },
  {
    id: "2497",
    word: "benzyna"
  },
  {
    id: "2500",
    word: "rodzaj"
  },
  {
    id: "2502",
    word: "reklamować"
  },
  {
    id: "2508",
    word: "suszarka"
  },
  {
    id: "2512",
    word: "łóżko piętrowe"
  },
  {
    id: "2514",
    word: "przyjęcie"
  },
  {
    id: "2517",
    word: "środek do prania"
  },
  {
    id: "2523",
    word: "elektryczność"
  },
  {
    id: "2525",
    word: "laser"
  },
  {
    id: "2546",
    word: "konduktor/konduktorka"
  },
  {
    id: "2551",
    word: "dług"
  },
  {
    id: "2555",
    word: "staw"
  },
  {
    id: "2560",
    word: "sterowiec"
  },
  {
    id: "2572",
    word: "wylot"
  },
  {
    id: "2578",
    word: "siedziba"
  },
  {
    id: "2581",
    word: "trampki"
  },
  {
    id: "2590",
    word: "narciarstwo"
  },
  {
    id: "2596",
    word: "organizacja charytatywna"
  },
  {
    id: "2602",
    word: "bratanek/siostrzeniec"
  },
  {
    id: "2610",
    word: "harcerz/harcerka"
  },
  {
    id: "2612",
    word: "przeznaczenie"
  },
  {
    id: "2613",
    word: "aparat na zęby"
  },
  {
    id: "2623",
    word: "wieżowiec"
  },
  {
    id: "2643",
    word: "dwukropek"
  },
  {
    id: "2649",
    word: "przeciwieństwo"
  },
  {
    id: "2653",
    word: "postura"
  },
  {
    id: "2654",
    word: "kwaśny"
  },
  {
    id: "2656",
    word: "era"
  },
  {
    id: "2660",
    word: "welon"
  },
  {
    id: "2662",
    word: "zawody"
  },
  {
    id: "2664",
    word: "klamerka"
  },
  {
    id: "2669",
    word: "południowy zachód"
  },
  {
    id: "2682",
    word: "śmietnisko"
  },
  {
    id: "2686",
    word: "plotka"
  },
  {
    id: "2698",
    word: "bekon"
  },
  {
    id: "2699",
    word: "słowa piosenki"
  },
  {
    id: "2712",
    word: "zadrapanie"
  },
  {
    id: "2713",
    word: "opatrunek"
  },
  {
    id: "2719",
    word: "krasnal"
  },
  {
    id: "2720",
    word: "odpowiedzialność prawna"
  },
  {
    id: "2723",
    word: "wers"
  },
  {
    id: "2725",
    word: "but na wysokim obcasie"
  },
  {
    id: "2730",
    word: "kolumna"
  },
  {
    id: "2732",
    word: "rozdzielczość"
  },
  {
    id: "2733",
    word: "narodowy"
  },
  {
    id: "2736",
    word: "niezwykły"
  },
  {
    id: "2741",
    word: "rejestracja"
  },
  {
    id: "2745",
    word: "zbocze góry"
  },
  {
    id: "2763",
    word: "zdolność"
  },
  {
    id: "2772",
    word: "koc"
  },
  {
    id: "2775",
    word: "mamrotanie"
  },
  {
    id: "2784",
    word: "strażnik leśny/strażniczka leśna"
  },
  {
    id: "2785",
    word: "atrakcja turystyczna"
  },
  {
    id: "2786",
    word: "ogród"
  },
  {
    id: "2788",
    word: "obowiązkowy"
  },
  {
    id: "2791",
    word: "grill"
  },
  {
    id: "2796",
    word: "poprzedni"
  },
  {
    id: "2798",
    word: "prosty/prosto"
  },
  {
    id: "2804",
    word: "monotonny"
  },
  {
    id: "2805",
    word: "wliczony"
  },
  {
    id: "2813",
    word: "kotwica"
  },
  {
    id: "2819",
    word: "propozycja"
  },
  {
    id: "2824",
    word: "Święto Dziękczynienia"
  },
  {
    id: "2826",
    word: "podstawa"
  },
  {
    id: "2833",
    word: "własny"
  },
  {
    id: "2836",
    word: "poduszka do siedzenia"
  },
  {
    id: "2838",
    word: "łup"
  },
  {
    id: "2839",
    word: "popcorn"
  },
  {
    id: "2841",
    word: "odcinek"
  },
  {
    id: "2845",
    word: "oprócz"
  },
  {
    id: "2848",
    word: "pytajnik"
  },
  {
    id: "2852",
    word: "lupa"
  },
  {
    id: "2853",
    word: "pożądanie"
  },
  {
    id: "2855",
    word: "kolega/koleżanka z klasy"
  },
  {
    id: "2864",
    word: "akcja"
  },
  {
    id: "2865",
    word: "wieś"
  },
  {
    id: "2866",
    word: "około"
  },
  {
    id: "2887",
    word: "zmarszczka"
  },
  {
    id: "2891",
    word: "tryktrak"
  },
  {
    id: "2892",
    word: "bieżnia"
  },
  {
    id: "2896",
    word: "być może"
  },
  {
    id: "2898",
    word: "traktor"
  },
  {
    id: "2903",
    word: "sitko"
  },
  {
    id: "2904",
    word: "kamerdyner"
  },
  {
    id: "2908",
    word: "ledwie"
  },
  {
    id: "2909",
    word: "wstawać"
  },
  {
    id: "2911",
    word: "karton"
  },
  {
    id: "2918",
    word: "plaster"
  },
  {
    id: "2921",
    word: "łagodny"
  },
  {
    id: "2927",
    word: "odwrót"
  },
  {
    id: "2929",
    word: "niemy"
  },
  {
    id: "2938",
    word: "buda dla psa"
  },
  {
    id: "2951",
    word: "wolny"
  },
  {
    id: "2954",
    word: "okiennica"
  },
  {
    id: "2969",
    word: "rejestrator"
  },
  {
    id: "2974",
    word: "uprzejmość"
  },
  {
    id: "2975",
    word: "jasny"
  },
  {
    id: "2976",
    word: "kość policzkowa"
  },
  {
    id: "2978",
    word: "podróżnik"
  },
  {
    id: "2982",
    word: "przypomnienie"
  },
  {
    id: "2986",
    word: "pobrać"
  },
  {
    id: "2989",
    word: "nadgodziny"
  },
  {
    id: "3004",
    word: "ambitny"
  },
  {
    id: "3005",
    word: "odbijać"
  },
  {
    id: "3006",
    word: "animacja"
  },
  {
    id: "3012",
    word: "proces"
  },
  {
    id: "3020",
    word: "pracowity"
  },
  {
    id: "3024",
    word: "obserwacja"
  },
  {
    id: "3025",
    word: "poprawny"
  },
  {
    id: "3028",
    word: "nosiciel"
  },
  {
    id: "3029",
    word: "zaręczyny"
  },
  {
    id: "3035",
    word: "południowy wschód"
  },
  {
    id: "3042",
    word: "nagranie"
  },
  {
    id: "3048",
    word: "niewrażliwy"
  },
  {
    id: "3057",
    word: "kosmos"
  },
  {
    id: "3062",
    word: "niewidomy"
  },
  {
    id: "3065",
    word: "gwiazda"
  },
  {
    id: "3073",
    word: "poprawić"
  },
  {
    id: "3074",
    word: "wydanie"
  },
  {
    id: "3076",
    word: "tłumaczyć"
  },
  {
    id: "3085",
    word: "kontynuować"
  },
  {
    id: "3089",
    word: "sława"
  },
  {
    id: "3091",
    word: "wadliwy"
  },
  {
    id: "3093",
    word: "niepodległość"
  },
  {
    id: "3096",
    word: "etui"
  },
  {
    id: "3098",
    word: "potrząsnąć"
  },
  {
    id: "3099",
    word: "uzależniony od narkotyków"
  },
  {
    id: "3106",
    word: "inny"
  },
  {
    id: "3108",
    word: "gniazdko"
  },
  {
    id: "3110",
    word: "wybory"
  },
  {
    id: "3114",
    word: "kolec"
  },
  {
    id: "3116",
    word: "miły"
  },
  {
    id: "3121",
    word: "okruch"
  },
  {
    id: "3123",
    word: "wydawać"
  },
  {
    id: "3125",
    word: "pasza"
  },
  {
    id: "3126",
    word: "zajęty"
  },
  {
    id: "3132",
    word: "obsada"
  },
  {
    id: "3136",
    word: "porażka"
  },
  {
    id: "3140",
    word: "obserwujący"
  },
  {
    id: "3142",
    word: "twardy"
  },
  {
    id: "3145",
    word: "cały"
  },
  {
    id: "3147",
    word: "ścierka"
  },
  {
    id: "3148",
    word: "obowiązek"
  },
  {
    id: "3149",
    word: "zabawny/zabawnie"
  },
  {
    id: "3154",
    word: "warsztat"
  },
  {
    id: "3173",
    word: "stary"
  },
  {
    id: "3174",
    word: "połykać"
  },
  {
    id: "3191",
    word: "ketmia piżmowa"
  },
  {
    id: "3196",
    word: "legalny"
  },
  {
    id: "3200",
    word: "wyjść"
  },
  {
    id: "3211",
    word: "bliskość"
  },
  {
    id: "3212",
    word: "rzęsa"
  },
  {
    id: "3213",
    word: "oszczędność"
  },
  {
    id: "3217",
    word: "Wielka Brytania"
  },
  {
    id: "3218",
    word: "żłobek"
  },
  {
    id: "3220",
    word: "magnituda"
  },
  {
    id: "3228",
    word: "armata"
  },
  {
    id: "3231",
    word: "zręczny"
  },
  {
    id: "3234",
    word: "ciasny"
  },
  {
    id: "3235",
    word: "znaczek pocztowy"
  },
  {
    id: "3236",
    word: "cząsteczka"
  },
  {
    id: "3240",
    word: "niemiły"
  },
  {
    id: "3247",
    word: "dzbanek"
  },
  {
    id: "3252",
    word: "niezdarny"
  },
  {
    id: "3261",
    word: "brat/siostra"
  },
  {
    id: "3264",
    word: "wyjątkowy"
  },
  {
    id: "3267",
    word: "antena"
  },
  {
    id: "3273",
    word: "zorganizować"
  },
  {
    id: "3279",
    word: "naprawdę"
  },
  {
    id: "3280",
    word: "przedłużenie"
  },
  {
    id: "3290",
    word: "nagła potrzeba"
  },
  {
    id: "3292",
    word: "przyprawa"
  },
  {
    id: "3296",
    word: "zauważyć"
  },
  {
    id: "3300",
    word: "wspaniały"
  },
  {
    id: "3301",
    word: "partnerstwo"
  },
  {
    id: "3304",
    word: "wygodny"
  },
  {
    id: "3306",
    word: "miesięczny"
  },
  {
    id: "3308",
    word: "męczący"
  },
  {
    id: "3313",
    word: "podekscytowany"
  },
  {
    id: "3330",
    word: "w środku"
  },
  {
    id: "3337",
    word: "buldożer"
  },
  {
    id: "3357",
    word: "mądry"
  },
  {
    id: "3363",
    word: "kołyska"
  },
  {
    id: "3365",
    word: "nieuważny"
  },
  {
    id: "3366",
    word: "aromat"
  },
  {
    id: "3369",
    word: "przyzwoity"
  },
  {
    id: "3371",
    word: "napis"
  },
  {
    id: "3378",
    word: "przegrana"
  },
  {
    id: "3379",
    word: "mleczko do opalania"
  },
  {
    id: "3381",
    word: "obok"
  },
  {
    id: "3382",
    word: "gumowce"
  },
  {
    id: "3390",
    word: "zanieczyszczać"
  },
  {
    id: "3403",
    word: "zamieszki"
  },
  {
    id: "3405",
    word: "śruba"
  },
  {
    id: "3408",
    word: "ambasada"
  },
  {
    id: "3410",
    word: "oskarżenie"
  },
  {
    id: "3415",
    word: "unikać"
  },
  {
    id: "3417",
    word: "trzepaczka do jajek"
  },
  {
    id: "3418",
    word: "znikać"
  },
  {
    id: "3420",
    word: "górne piętro"
  },
  {
    id: "3423",
    word: "dowiedzieć się"
  },
  {
    id: "3424",
    word: "zamach stanu"
  },
  {
    id: "3432",
    word: "okrągły"
  },
  {
    id: "3437",
    word: "powrót do zdrowia"
  },
  {
    id: "3439",
    word: "zabawny"
  },
  {
    id: "3442",
    word: "oswojony"
  },
  {
    id: "3444",
    word: "śnić"
  },
  {
    id: "3446",
    word: "Cygan/Cyganka"
  },
  {
    id: "3449",
    word: "kwalifikujący się"
  },
  {
    id: "3453",
    word: "przebieralnia"
  },
  {
    id: "3455",
    word: "zgadzać się"
  },
  {
    id: "3459",
    word: "zeznanie"
  },
  {
    id: "3465",
    word: "wóz strażacki"
  },
  {
    id: "3473",
    word: "podróż tam i z powrotem"
  },
  {
    id: "3488",
    word: "narzeczony"
  },
  {
    id: "2861",
    word: "specjalnie"
  },
  {
    id: "2878",
    word: "wirtualny"
  },
  {
    id: "2882",
    word: "scena"
  },
  {
    id: "3176",
    word: "spuchnięty"
  },
  {
    id: "3188",
    word: "na zewnątrz"
  },
  {
    id: "3097",
    word: "bliski/blisko"
  }
];



// WEBPACK FOOTER //
// ./src/containers/Words/pl.js